export default class PhoneValidator {
    static validate(phoneNumber) {
        const phoneNumberFormat = /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g;
        return phoneNumber.match(phoneNumberFormat);
    }
}